// Bảng NỔI của khung "Sơ đồ các bước" (04/10/2026, docs/phan-tich-ux-so-do.md): đặt bảng chọn thao tác / menu ⋯ ngay cạnh nút bấm
// (không cuộn trang — V1/V2), phím của menu (WAI-ARIA menu), hiệu ứng FLIP khi thẻ đổi chỗ. Logic vị trí thuần ở src/shared/so-do-sua.ts.
import { viTriPopover } from "../../../../src/shared/so-do-sua";

const THANH_TREN = 56; // --top-h: thanh trên dính
const thanhDay = (): number => (matchMedia("(max-width: 1023px)").matches ? 60 : 0); // --nav-h: thanh điều hướng đáy ở màn hẹp

/**
 * (07/10/2026, E2E K1/K1b boss-so-do-sua) Phần ĐÁY khung nhìn đang bị các thanh NỔI của trang chiếm: thanh "Hoàn tác" (.kb-ht-noi) và hộp lỗi nổi
 * (.kb-loi-noi) — cả hai position: fixed ở đáy, z-index 38, nằm TRÊN bảng "+" / menu ⋯ (z-index 5). Trước đây bảng được phép mở xuống tới sát đáy
 * màn → nút "Thêm vào sơ đồ" nằm dưới thanh Hoàn tác, bấm trúng thanh. Trả số px tính từ đáy khung nhìn tới mép TRÊN cao nhất của các thanh đang hiện.
 */
export function dayBiChe(): number {
  let tren = innerHeight;
  for (const el of document.querySelectorAll<HTMLElement>(".kb-ht-noi, .kb-loi-noi")) {
    if (el.hidden || !el.isConnected) continue;
    const r = el.getBoundingClientRect();
    if (r.width > 0 && r.height > 0 && r.top < tren) tren = r.top;
  }
  return Math.max(0, innerHeight - tren);
}

/**
 * Đặt `pop` (con của `chua`, chua có position: relative) cạnh nút `neo`: dưới nút nếu đủ chỗ, không thì trên; ≤ 640 px → bảng trượt từ
 * dưới lên (fixed, đáy màn hình, không che nút neo nếu còn ≥ 300 px). `huong` = hướng đã chọn lần mở trước (vẽ lại giữ nguyên, bảng không
 * nhảy từ dưới lên trên khi nội dung dài ra). Trả hướng đã dùng.
 */
export function datViTriNoi(pop: HTMLElement, neo: HTMLElement, chua: HTMLElement, huong?: "duoi" | "tren", canPhai = false): "duoi" | "tren" | "sheet" {
  const rn = neo.getBoundingClientRect();
  const cuon = pop.scrollTop; // đo chiều cao tự nhiên làm mất chỗ cuộn trong bảng — trả lại sau
  pop.style.maxHeight = "none";
  pop.style.left = ""; pop.style.top = "";
  const khung = { rong: document.documentElement.clientWidth, cao: innerHeight };
  const caoCan = pop.offsetHeight;
  // canPhai: mép PHẢI bảng thẳng mép phải nút (menu ⋯ ở góc phải thẻ — không tràn sang cột bên cạnh)
  const trai = canPhai ? rn.right - pop.offsetWidth : rn.left;
  const mepDuoi = dayBiChe(); // thanh Hoàn tác / hộp lỗi nổi đang hiện ở đáy: bảng không được mở xuống phần bị chúng che
  let vt = viTriPopover({ trai, tren: rn.top, rong: rn.width, cao: rn.height }, pop.offsetWidth, caoCan, khung, { mepTren: THANH_TREN, mepDuoi });
  if (vt.kieu === "sheet") {
    pop.dataset.kieu = "sheet";
    // bảng trượt từ đáy: nhấc lên trên các thanh nổi (thay vì nằm dưới chúng)
    pop.style.bottom = mepDuoi ? `${Math.round(mepDuoi)}px` : "";
    pop.style.maxHeight = `${Math.round(Math.min((khung.cao - mepDuoi) * 0.85, Math.max(300, khung.cao - mepDuoi - rn.bottom - 8)))}px`;
    pop.scrollTop = cuon;
    return "sheet";
  }
  pop.style.bottom = "";
  if (huong && huong !== vt.huong) {
    const choDuoi = khung.cao - mepDuoi - 8 - (rn.bottom + 8), choTren = rn.top - 8 - (THANH_TREN + 8);
    const cao = Math.max(0, huong === "duoi" ? choDuoi : choTren);
    if (cao >= Math.min(caoCan, 240)) vt = { ...vt, huong, caoToiDa: cao, tren: huong === "duoi" ? rn.bottom + 8 : rn.top - 8 - Math.min(caoCan, cao) };
  }
  // position: fixed theo toạ độ KHUNG NHÌN (04/10, E2E KB14): bảng absolute trong thẻ giữ toạ độ cũ khi đổi cỡ cửa sổ → tràn ngang trang tới lần
  // vẽ lại sau; fixed thì không bao giờ làm trang rộng ra. Trang đặt lại vị trí khi cuộn / đổi cỡ (bám theo nút).
  void chua;
  pop.dataset.kieu = "noi";
  pop.dataset.huong = vt.huong;
  pop.style.maxHeight = `${Math.round(vt.caoToiDa)}px`;
  pop.style.left = `${Math.round(vt.trai)}px`;
  // lật lên: đáy bảng sát trên nút (chiều cao thật sau khi giới hạn)
  const caoThat = Math.min(caoCan, vt.caoToiDa);
  pop.style.top = `${Math.round(vt.huong === "duoi" ? vt.tren : rn.top - 8 - caoThat)}px`;
  pop.scrollTop = cuon;
  return vt.huong;
}

/** Menu WAI-ARIA: ↑/↓ (vòng), Home/End di chuyển con trỏ giữa các mục (kể cả mục bị khoá — người dùng trình đọc màn hình nghe được lý
 *  do); Esc đóng và trả con trỏ về nút mở; Tab đóng. */
export function ganPhimMenu(menu: HTMLElement, dong: (traTieuDiem: boolean) => void): void {
  menu.addEventListener("keydown", (e) => {
    const muc = [...menu.querySelectorAll<HTMLElement>('[role="menuitem"]')];
    const i = muc.indexOf(document.activeElement as HTMLElement);
    const toi = (j: number): void => { e.preventDefault(); muc[(j + muc.length) % muc.length]?.focus({ preventScroll: true }); };
    if (e.key === "ArrowDown") toi(i + 1);
    else if (e.key === "ArrowUp") toi(i < 0 ? muc.length - 1 : i - 1);
    else if (e.key === "Home") toi(0);
    else if (e.key === "End") toi(muc.length - 1);
    else if (e.key === "Escape") { e.preventDefault(); e.stopPropagation(); dong(true); }
    else if (e.key === "Tab") dong(false);
  });
}

/** Ảnh vị trí các phần tử (theo khoá) trước khi vẽ lại → sau khi vẽ lại, phần tử cùng khoá trượt từ chỗ cũ tới chỗ mới (150 ms). */
export function chupViTri(els: Iterable<[string, HTMLElement]>): Map<string, DOMRect> {
  const m = new Map<string, DOMRect>();
  for (const [k, el] of els) m.set(k, el.getBoundingClientRect());
  return m;
}
export function truotFlip(truoc: Map<string, DOMRect>, sau: Iterable<[string, HTMLElement]>, boQua?: string): void {
  if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  for (const [k, el] of sau) {
    const r0 = truoc.get(k);
    if (!r0 || k === boQua) continue;
    const r1 = el.getBoundingClientRect();
    const dx = r0.left - r1.left, dy = r0.top - r1.top;
    if (Math.abs(dx) < 1 && Math.abs(dy) < 1) continue;
    el.animate?.([{ transform: `translate(${dx}px, ${dy}px)` }, { transform: "none" }], { duration: 150, easing: "cubic-bezier(.2,.7,.3,1)" });
  }
}

/** Cuộn mượt TỐI THIỂU để phần tử vào khung nhìn (chừa thanh trên / thanh đáy). */
export { thanhDay, THANH_TREN };
